import React from "react";
import { useLocale } from "@insightfulscience/smart-react/i18";
import PageMeta from "@insightfulscience/smart-react/PageMeta";
import SimpleTemplate from "@insightfulscience/atomic-react/SimpleTemplate";
import SimpleTemplateTitle from "@insightfulscience/atomic-react/SimpleTemplate/Title";
import SimpleTemplateDescription from "@insightfulscience/atomic-react/SimpleTemplate/Description";
import pipe from "@insightfulscience/shared-utils/fn/pipe";
import propsResolver from "@insightfulscience/shared-utils/fn/props-resolver";
import QuoteForm from "../../QuoteForm";
import WithServices from "../../services";
import SiteLayout from "../../SiteLayout";
import getCountriesProvider from "../../services/countryService";

const QuoteRequested = () => {
	const [t] = useLocale("quote-requested");

	return (
		<SiteLayout>
			<PageMeta title={t("META.TITLE")} description={t("META.DESCRIPTION")}>
				<PageMeta.OGP
					locale={t("META.LOCALE")}
					type={t("META.TYPE")}
					title={t("META.TITLE")}
					description={t("META.DESCRIPTION")}
					url={t("META.URL")}
					siteName={t("META.SITE_NAME")}
					articlePublisher={t("META.ARTICLE_PUBLISHER")}
					image={t("META.IMAGE")}
					isImageBaseUrl
				/>
				<PageMeta.Canonical href={t("META.CANONICAL")} />
				<PageMeta.Twitter
					card={t("META.TWITTER_CARD")}
					title={t("META.TITLE")}
					description={t("META.DESCRIPTION")}
					site={t("META.TWITTER_SITE")}
					creator={t("META.TWITTER_CREATOR")}
				/>
			</PageMeta>
			<SimpleTemplate utility={{ bgColor: 4 }}>
				<SimpleTemplateTitle>{t("FORM_TITLE")}</SimpleTemplateTitle>
				<SimpleTemplateDescription>{t("FORM_DESCRIPTION")}</SimpleTemplateDescription>
				<QuoteForm />
			</SimpleTemplate>
		</SiteLayout>
	);
};

QuoteRequested.services = {
	getCountries: getCountriesProvider,
};

QuoteRequested.getInitialProps = propsResolver({
	countries: (_, { getCountries }) => getCountries(),
});

export default pipe(QuoteRequested, WithServices);
